import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="price-field"
export default class extends Controller {
  static targets = ['source', 'destination']
  static values = {
    currencyCode: String
  }

  connect() {
    this.destinationTarget.innerHTML = "= " +(this.sourceTarget.value / 1000.0).toFixed(3) + this.htmlCurrencyCode;

    this.sourceTarget.addEventListener('input', () => {
      this.destinationTarget.innerHTML = "= " + (this.sourceTarget.value / 1000.0).toFixed(3) + this.htmlCurrencyCode;
    })
  }

  get htmlCurrencyCode() {
    if (this.currencyCodeValue == 'EUR') {
      return '&euro;';
    } else {
      return 'Kč';
    }
  }
}
